import { render, staticRenderFns } from "./HorizontalTabHeaderDropdown.vue?vue&type=template&id=811f0d7e&scoped=true&"
import script from "./HorizontalTabHeaderDropdown.vue?vue&type=script&lang=js&"
export * from "./HorizontalTabHeaderDropdown.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalTabHeaderDropdown.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HorizontalTabHeaderDropdown.vue?vue&type=style&index=1&id=811f0d7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811f0d7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VList,VListItemGroup})
